import { render } from "./coursewareList.vue?vue&type=template&id=43b48ab7&scoped=true"
import script from "./coursewareList.vue?vue&type=script&lang=js"
export * from "./coursewareList.vue?vue&type=script&lang=js"

import "./coursewareList.vue?vue&type=style&index=0&id=43b48ab7&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b48ab7"]])

export default __exports__